module.exports = __webpack_public_path__ + "img/aov.b3a04a83.jpg";